import React, { useCallback, useEffect, useState, lazy } from 'react';
export function Hero() {
  const handleBuyClick = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 19990,
        currency: 'ARS'
      });
    }
  };
  // Spots counter — starts at 23, decreases by 1 every 4-9 min
  const [spots, setSpots] = useState(() => {
    const saved = sessionStorage.getItem('hero_spots');
    return saved ? parseInt(saved, 10) : 23;
  });
  useEffect(() => {
    const tick = () => {
      setSpots(prev => {
        const next = Math.max(prev - 1, 3);
        sessionStorage.setItem('hero_spots', String(next));
        return next;
      });
      schedule();
    };
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const delay = (Math.random() * 5 + 4) * 60 * 1000; // 4-9 min
      timer = setTimeout(tick, delay);
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);
  // Countdown timer — 11h 33m 11s from first visit
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('hero_countdown_end');
    if (saved) {
      const remaining = parseInt(saved, 10) - Date.now();
      return Math.max(remaining, 0);
    }
    const duration = (11 * 3600 + 33 * 60 + 11) * 1000;
    sessionStorage.setItem('hero_countdown_end', String(Date.now() + duration));
    return duration;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      const end = parseInt(sessionStorage.getItem('hero_countdown_end') || '0', 10);
      const remaining = Math.max(end - Date.now(), 0);
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600000);
  const minutes = Math.floor(timeLeft % 3600000 / 60000);
  const seconds = Math.floor(timeLeft % 60000 / 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="hero flex flex-col items-center justify-center pt-[24px] md:pt-[72px] px-4 md:px-5 pb-[24px] md:pb-[60px] overflow-hidden bg-[radial-gradient(ellipse_100%_80%_at_50%_0%,rgba(44,37,64,0.25)_0%,transparent_60%)] relative z-10" data-id="element-242">
      <div className="c flex flex-col items-center relative z-10 w-full" data-id="element-243">
        <div className="hero-badge fu inline-flex items-center justify-center gap-[7px] py-2 px-4 md:px-5 rounded-full border border-[rgba(232,150,12,0.6)] bg-[rgba(232,150,12,0.14)] text-[11px] md:text-[12px] tracking-[0.16em] uppercase text-[var(--gold-l)] font-900 mb-2 md:mb-[22px] backdrop-blur-sm text-center shadow-[0_0_20px_rgba(232,150,12,0.15)]" data-id="element-244">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" data-id="element-245">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-246" />
          </svg>
          Rituales para dolores que no caben en palabras
        </div>

        <h1 className="fu font-serif text-[clamp(3rem,9vw,5.8rem)] font-700 leading-[1.15] text-center text-white tracking-[-0.01em] mb-2 md:mb-[18px]" style={{
        transitionDelay: '.12s'
      }} data-id="element-247">
          Tu mente ya entendió.
          <br data-id="element-248" />
          <em className="italic text-[var(--gold-l)]" data-id="element-249">
            Tu cuerpo todavía no lo soltó.
          </em>
        </h1>

        <p className="hero-sub fu font-serif text-[clamp(1.1rem,2.5vw,1.5rem)] text-[var(--lila-pale)] text-center italic max-w-[600px] mb-2 md:mb-5 leading-[1.45]" style={{
        transitionDelay: '.22s'
      }} data-id="element-250">
          ¡ESTE DOLOR NO ES MIO.{' '}
          <strong className="text-[var(--gold-l)] font-900 not-italic" data-id="element-251">
            SOLTÁ EN 21 DIAS
          </strong>{' '}
          AQUELLO QUE NO TE PERTENECE!
        </p>

        <div className="fu w-full max-w-[600px] mb-3 md:mb-7 relative rounded-[14px] overflow-hidden" style={{
        transitionDelay: '.27s'
      }} data-id="element-252">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(184,174,206,0.15)_0%,transparent_70%)] pointer-events-none z-10" data-id="element-253" />
          <img src="https://cdn.magicpatterns.com/uploads/nSSXsfKLDCM8MXvbBCX7Lo/20260323_0907_Image_Generation_simple_compose_01kmd9et3cfvtvg0m45eqxvx91.png" alt="Ritual de sanación y liberación emocional" loading="lazy" className="w-full rounded-[14px] border-2 border-[var(--gold)] shadow-[0_16px_48px_-12px_rgba(44,37,64,0.5),0_0_30px_-8px_rgba(232,150,12,0.25)] block" data-id="element-254" />
        </div>

        <div className="fu flex flex-col items-center gap-2.5 w-full mb-3 md:mb-[36px]" style={{
        transitionDelay: '.32s'
      }} data-id="element-255">
          <a href="#pricing-card" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing-card')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="btn-cta full text-center" data-id="element-256">
            Quiero mi Kit Completo $19.990
          </a>

          {/* URGENCY BAR — Two layers */}
          <div className="w-full max-w-[600px] mt-3 rounded-xl overflow-hidden border border-[rgba(232,150,12,0.25)] shadow-[0_4px_20px_rgba(0,0,0,0.3)]" data-id="element-257">
            {/* Top strip — spots counter */}
            <div className="bg-[linear-gradient(90deg,rgba(101,67,33,0.6),rgba(139,90,43,0.5),rgba(101,67,33,0.6))] border-b border-[rgba(232,150,12,0.2)] py-2.5 px-4 text-center" data-id="element-258">
              <p className="text-[clamp(0.7rem,1.8vw,0.82rem)] tracking-[0.08em] text-[var(--gold-l)] font-700 leading-[1.4]" data-id="element-259">
                <span className="text-[var(--flame2)]" data-id="element-260">⚡</span>{' '}
                <span className="uppercase" data-id="element-261">Precio de lanzamiento</span>
                {' — '}
                Quedan{' '}
                <span className="text-white font-900 text-[clamp(0.8rem,2vw,0.95rem)]" data-id="element-262">
                  {spots}
                </span>{' '}
                accesos a este precio · Sube a{' '}
                <span className="text-white font-900" data-id="element-263">$29.990</span> cuando se
                agoten
              </p>
            </div>
            {/* Bottom strip — countdown */}
            <div className="bg-[rgba(12,10,20,0.85)] py-3 px-4 flex items-center justify-center gap-3" data-id="element-264">
              <span className="text-[clamp(0.6rem,1.4vw,0.72rem)] tracking-[0.15em] uppercase text-[var(--text)] font-700 opacity-80" data-id="element-265">
                Oferta vence en:
              </span>
              <div className="flex items-center gap-1.5" data-id="element-266">
                <div className="bg-[rgba(232,150,12,0.12)] border border-[rgba(232,150,12,0.35)] rounded-lg px-2.5 py-1.5 min-w-[48px] text-center" data-id="element-267">
                  <div className="font-serif text-[clamp(1.2rem,3.5vw,1.6rem)] text-[var(--gold-l)] font-900 leading-none" data-id="element-268">
                    {pad(hours)}
                  </div>
                  <div className="text-[8px] tracking-[0.15em] uppercase text-[var(--muted)] mt-0.5 font-700" data-id="element-269">
                    HRS
                  </div>
                </div>
                <span className="text-[var(--gold)] text-[clamp(1rem,2.5vw,1.3rem)] font-700 opacity-60" data-id="element-270">
                  :
                </span>
                <div className="bg-[rgba(232,150,12,0.12)] border border-[rgba(232,150,12,0.35)] rounded-lg px-2.5 py-1.5 min-w-[48px] text-center" data-id="element-271">
                  <div className="font-serif text-[clamp(1.2rem,3.5vw,1.6rem)] text-[var(--gold-l)] font-900 leading-none" data-id="element-272">
                    {pad(minutes)}
                  </div>
                  <div className="text-[8px] tracking-[0.15em] uppercase text-[var(--muted)] mt-0.5 font-700" data-id="element-273">
                    MIN
                  </div>
                </div>
                <span className="text-[var(--gold)] text-[clamp(1rem,2.5vw,1.3rem)] font-700 opacity-60" data-id="element-274">
                  :
                </span>
                <div className="bg-[rgba(232,150,12,0.12)] border border-[rgba(232,150,12,0.35)] rounded-lg px-2.5 py-1.5 min-w-[48px] text-center" data-id="element-275">
                  <div className="font-serif text-[clamp(1.2rem,3.5vw,1.6rem)] text-[var(--gold-l)] font-900 leading-none" data-id="element-276">
                    {pad(seconds)}
                  </div>
                  <div className="text-[8px] tracking-[0.15em] uppercase text-[var(--muted)] mt-0.5 font-700" data-id="element-277">
                    SEG
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="trust flex items-center gap-2 text-[11px] md:text-[12px] text-[var(--text)] opacity-75 mt-2 flex-wrap justify-center" data-id="element-278">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-279">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-280" />
            </svg>
            Pago seguro · Descarga inmediata · Garantía 7 días
          </div>
        </div>

        <p className="hero-body fu text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] text-center max-w-[600px] mb-3 md:mb-[36px] leading-[1.6] md:leading-[1.9] opacity-90 font-400" style={{
        transitionDelay: '.38s'
      }} data-id="element-281">
          Un proceso guiado y diseñado para cerrar ciclos emocionales que tu
          mente no ha podido soltar. En pocos días pasarás de sentirte atrapada
          en recuerdos, pensamientos repetitivos y emociones que pesan…a
          experimentar una sensación real de{' '}
          <strong className="text-[var(--gold-l)] font-700" data-id="element-282">liberación</strong>,{' '}
          <strong className="text-[var(--gold-l)] font-700" data-id="element-283">claridad</strong> y{' '}
          <strong className="text-[var(--gold-l)] font-700" data-id="element-284">
            tranquilidad emocional
          </strong>
          .
        </p>

        <div className="hero-img-w fu mt-4 md:mt-[44px] relative" style={{
        transitionDelay: '.52s'
      }} data-id="element-285">
          <div className="absolute -inset-6 bg-[radial-gradient(circle,rgba(184,174,206,0.4)_0%,rgba(255,107,53,0.15)_40%,transparent_70%)] rounded-full blur-[16px]" data-id="element-286" />
          <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BUNDLE.png?v=1772835860" alt="33 Rituales para Soltar el Pasado — Kit Completo" loading="lazy" className="relative z-10 w-[clamp(180px,min(80vw,280px),350px)] md:w-[clamp(200px,min(85vw,300px),400px)] rounded-[10px] border border-[rgba(184,174,206,0.3)] shadow-[0_24px_70px_-15px_rgba(44,37,64,0.6),0_8px_32px_rgba(255,107,53,0.15)] mx-auto block" data-id="element-287" />
        </div>
      </div>
    </section>;
}